import * as React from 'react';
import clx from 'classnames';
import './RequestSendSuccessMessage.scss';
import { Link } from 'react-router-dom';
import { Button, Card, Result } from 'antd';
import { IProcedure } from 'common/schema/Procedure';
import { IRequest, RequestState } from 'common/schema/request/Request';
import { LoaderSpin } from 'client/ui/loader/LoaderSpin';
import {
  useCurrentUser,
  usePermissions
} from 'client/components/auth/AuthModule';
import { ProcedureLinkText } from 'client/ui/naming/ProcedureLinkText';
import { UserLogic } from 'common/schema/UserLogic';
import { RequestProcessingMessage } from '../waiting/RequestProcessingMessage';

export interface RequestSendSuccessMessageProps {
  procedure: IProcedure;
  request: Maybe<IRequest>;
  loading?: boolean;
}

export function RequestSendSuccessMessage(
  props: RequestSendSuccessMessageProps
) {
  const { loading, procedure, request } = props;
  const permissions = usePermissions();
  const user = useCurrentUser();

  // Testo di invio a email
  const recipientMail = UserLogic.recipientMailForRequest(
    user?.citizen,
    request
  );
  const emailNotificationContent = recipientMail && (
    <>
      <br />
      La ricevuta verrà inviata via email all'indirizzo {recipientMail}.
    </>
  );

  // Testo di protocollo
  const protocolContent = request?.protocolSignature && (
    <>
      <br />
      La segnatura di protocollo è: {request.protocolSignature}
    </>
  );

  if (loading || !request)
    return (
      <Card>
        <LoaderSpin transparent tip="Invio della domanda in corso.." />
      </Card>
    );

  if (
    request.state === RequestState.NeedRetry ||
    request.state === RequestState.Sending
  ) {
    return <RequestProcessingMessage procedure={procedure} request={request} />;
  }

  return (
    <Card className="request-send-success-message">
      <Result
        status="success"
        title="Domanda inviata con successo"
        subTitle={
          <>
            <>
              La domanda è stata registrata con successo. Il codice
              identificativo è: {request.code}.
            </>
            {protocolContent}
            {emailNotificationContent}
          </>
        }
        extra={[
          <>
            {permissions.has('request.read:own') && (
              <Link to={`/richieste/istanze`}>
                <Button type="primary" key="logged">
                  Le mie Istanze
                </Button>
              </Link>
            )}
          </>,
          <Link to={`/domande/${procedure.id}`}>
            <Button key="procedure">{ProcedureLinkText}</Button>
          </Link>
        ]}
      />
    </Card>
  );
}
